import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBdDquZqFTfmwnUusB8haHRort7AgcSD8Y",
  authDomain: "falsebayrefrigerationwebsite.firebaseapp.com",
  projectId: "falsebayrefrigerationwebsite",
  storageBucket: "falsebayrefrigerationwebsite.firebasestorage.app",
  messagingSenderId: "440993274290",
  appId: "1:440993274290:web:32ba8c3eee774475ccecab",
  measurementId: "G-HHR1TN5BW5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

isSupported().then((supported) => {
  if (supported) {
    getAnalytics(app);
  }
});

export { app };
